module.exports = __webpack_public_path__ + "3d38b375f42dae9072fd7ff72747b159.png";